import { Item } from "../Components/Navbar";

export const scrollToAnchor = (item: Item) => {
  const targetId = item.link.split("/#/")[1];
  const element = document.getElementById(targetId);
  const box = element?.getBoundingClientRect();
  const body = document.body;
  const docEl = document.documentElement;
  const clientTop = docEl.clientTop || body.clientTop || 0;
  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;

  if (element && box) {
    window.scrollTo({
      top:
        box.top +
        (scrollTop - clientTop) -
        (window.innerWidth <= 600 ? 100 : 155),
      behavior: "smooth",
    });
  } else {
    window.location.href = item.link;
  }
};
